class ImageComparison extends HTMLElement {
    constructor() {
        super();

        // console.log("ImageComparison 实例化");

        this.supportsPassive = false; // 将supportsPassive作为类的属性

        // console.log("开始初始化");
        this.detectPassiveSupport(); // 修改为调用正确的方法名
        this.init();
    }

    detectPassiveSupport() {
        try {
            const opts = Object.defineProperty({}, 'passive', {
                get: () => {
                    this.supportsPassive = true; // 更新类的属性
                }
            });
            window.addEventListener('testPassive', null, opts);
            window.removeEventListener('testPassive', null, opts);
        } catch (e) {
            // console.log("Passive event listeners not supported.");
        }
    }

    get button() {
        // console.log("获取按钮元素");
        return this.querySelector('button');
    }

    get bounding() {
        // console.log("获取元素边界信息");
        return this.getBoundingClientRect();
    }

    get horizontal() {
        const layout = this.dataset.layout === 'horizontal';
        // console.log("布局是否为水平布局:", layout);
        return layout;
    }

    get media() {
        // console.log("获取所有媒体元素 (img, svg)");
        return Array.from(this.querySelectorAll('img, svg'));
    }

    init() {
        // console.log("初始化 ImageComparison");

        this.active = false;

        // console.log("绑定 touchstart 事件");
        this.button.addEventListener('touchstart', this.startHandler.bind(this), this.supportsPassive ? { passive: true } : false);

        // console.log("绑定 touchend 事件");
        document.body.addEventListener('touchend', this.endHandler.bind(this), this.supportsPassive ? { passive: true } : false);

        // console.log("绑定 touchmove 事件");
        document.body.addEventListener('touchmove', this.onHandler.bind(this), this.supportsPassive ? { passive: true } : false);

        // console.log("绑定 mousedown 事件");
        this.button.addEventListener('mousedown', this.startHandler.bind(this));

        // console.log("绑定 mouseup 事件");
        document.body.addEventListener('mouseup', this.endHandler.bind(this));

        // console.log("绑定 mousemove 事件");
        document.body.addEventListener('mousemove', this.onHandler.bind(this));
    }

    startHandler() {
        // console.log("开始滑动");
        this.active = true;
        this.classList.add('scrolling');
    }

    endHandler() {
        // console.log("结束滑动");
        this.active = false;
        this.classList.remove('scrolling');
    }

    onHandler(e) {
        if (!this.active) return;

        // console.log("处理滑动事件");

        const event = (e.touches && e.touches[0]) || e;
        let x = this.horizontal
            ? event.pageX - (this.bounding.left + window.scrollX)
            : event.pageY - (this.bounding.top + window.scrollY);

        // console.log("滑动距离:", x);
        this.scrollIt(x);
    }

    scrollIt(x) {
        // console.log("开始滚动");

        const distance = this.horizontal ? this.clientWidth : this.clientHeight;
        // console.log("元素宽度或高度:", distance);
        const max = distance * 0.704861;
        const min = distance * 0.295138;
        const mouseX = Math.max(min, Math.min(x, max));
        const mousePercent = (mouseX * 100) / distance;

        // console.log("计算滚动百分比:", mousePercent + '%');
        this.style.setProperty('--percent', mousePercent + '%');
    }
}

customElements.define('image-comparison', ImageComparison);
